let components = [];

export function Spoiler(rootDom) {
    const selector = {
        OPENED: '_opened',
        CONTENT: 'js-spoiler-content',
    };
    const $toggle = $('.js-spoiler-toggle', rootDom);
    const $content = $(`.${selector.CONTENT}`, rootDom);
    const $closeOthersWrap = $(rootDom).closest('.js-spoiler-close-others');

    if (!$toggle.length) return;

    // HANDLERS
    $toggle.on('click', onToggle);

    // PRIVATE
    function onToggle() {
        const isOpened = $(rootDom).hasClass(selector.OPENED);

        // Закрываем остальные если есть обертка .js-spoiler-close-others
        if ($closeOthersWrap.length) {
            $closeOthersWrap
                .find(`.${selector.OPENED}`)
                .removeClass(selector.OPENED);
            $closeOthersWrap
                .find(`.${selector.CONTENT}`)
                .stop()
                .slideUp()
                .css('height', '');
        }

        isOpened ? hide() : show();
    }

    function hide() {
        $(rootDom).removeClass(selector.OPENED);
        $content.stop().slideUp().css('height', '');
    }

    function show() {
        $(rootDom).addClass(selector.OPENED);
        $content.stop().slideDown().css('height', '');
    }

    // PUBLIC
    function destroy() {
        $toggle.off('click', onToggle);
    }

    return {
        destroy
    };
}

// Инициализируем спойлер в новой странице
function init(e, data) {
    const pageContainerDom = data.next.container;

    components = Array.from(pageContainerDom.querySelectorAll('.js-spoiler')).map(Spoiler);
}

App.W.on("barba:afterEnter", init);
App.W.on('barba:leave', () => {
    if (components.length) {
        components.forEach(component => component.destroy());
        components = [];
    }
});



// WEBPACK FOOTER //
// ./_src/js/modules/Spoiler.js